var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationOffIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8401 23.5625L18.1101 20.8325H3.00011V19.8325L5.00011 17.8325V11.8325C5.00011 10.6925 5.29011 9.5625 5.83011 8.5525L1.11011 3.8325L2.39011 2.5625L22.1101 22.2925L20.8401 23.5625ZM19.0001 16.6325V11.8325C19.0001 8.7325 16.9701 6.0025 14.0001 5.1225C14.0001 5.0225 14.0001 4.9325 14.0001 4.8325C14.0001 4.30207 13.7894 3.79336 13.4143 3.41829C13.0392 3.04321 12.5305 2.8325 12.0001 2.8325C11.4697 2.8325 10.961 3.04321 10.5859 3.41829C10.2108 3.79336 10.0001 4.30207 10.0001 4.8325C10.0001 4.9325 10.0001 5.0225 10.0001 5.1225C9.39011 5.3025 8.80011 5.5725 8.26011 5.9225L19.0001 16.6325ZM12.0001 23.8325C12.5305 23.8325 13.0392 23.6218 13.4143 23.2467C13.7894 22.8716 14.0001 22.3629 14.0001 21.8325H10.0001C10.0001 22.3629 10.2108 22.8716 10.5859 23.2467C10.961 23.6218 11.4697 23.8325 12.0001 23.8325Z",
    fill: "#C7222A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationOffIcon);
export default __webpack_public_path__ + "static/media/notification-off-icon.b7bdcdc25e0ade5dbdf1a41c61215dfe.svg";
export { ForwardRef as ReactComponent };